import { createTheme } from "@mui/material/styles";
// assets
import MDZTheme from "./themes/mdz_theme";
import ZSWTheme from "./themes/zsw_theme";
import KILabTheme from "./themes/kilab_theme"; // project imports
import componentStyleOverrides from "./compStyleOverride";
import themePalette from "./palette";
import themeTypography from "./typography";
/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

/* Multi-Select Options */
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const multiSelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const theme = (name) => {
  let theming;

  switch (name) {
    case MDZTheme.abbreviation:
      theming = MDZTheme;
      break;
    case "ZSW":
      theming = ZSWTheme;
      break;
    case "KILAB":
      theming = KILabTheme;
      break;
    default:
      theming = MDZTheme;
  }

  const color = theming.colors;

  const themeOption = {
    colors: color,
    heading: color.primaryMain,
    paper: color.paper,
    backgroundDefault: color.grey100,
    background: color.grey100,
    darkTextPrimary: color.grey900,
    darkTextSecondary: color.grey600,
    darkTextTertiary: color.grey500,
    textDark: color.grey900,
    menuSelected: color.primaryDark,
    menuSelectedBack: color.primaryLight,
    menuItem: color.primaryLight,
    menuHover: color.primary800,
    divider: color.grey200,
    warning: color.warningMain,
    error: color.errorMain,
    success: color.successMain
  };

  const themeOptions = {
    direction: "ltr",
    palette: themePalette(themeOption),
    multiSelectMenuProps,
    mixins: {
      toolbar: {
        minHeight: "48px",
        padding: "16px",
        "@media (min-width: 600px)": {
          minHeight: "48px",
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0, // default
        sm: 600, // default
        md: 900, // default
        lg: 1536,
        xl: 2080,
      },
    },
    typography: themeTypography(themeOption),
    logo: theming.logo,
    aboutLogo: theming.aboutLogo,
    institutionName: theming.institutionName,
    abbreviation: theming.abbreviation,
    impressum: theming.impressum,
    dataProtection: theming.dataProtection,
  };

  const themes = createTheme(themeOptions);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;
